module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrapper"
  }, [_c('mu-appbar', {
    staticClass: "title",
    attrs: {
      "title": "发布话题"
    }
  }), _vm._v(" "), _c('main', [_c('mu-select-field', {
    staticClass: "text",
    attrs: {
      "labelFocusClass": ['label-foucs'],
      "label": "选择板块"
    },
    model: {
      value: (_vm.list),
      callback: function($$v) {
        _vm.list = $$v
      },
      expression: "list"
    }
  }, _vm._l((_vm.lists), function(text, index) {
    return _c('mu-menu-item', {
      key: index,
      attrs: {
        "value": index,
        "title": text
      }
    })
  }), 1), _vm._v(" "), _c('mu-text-field', {
    staticClass: "text",
    attrs: {
      "label": "标题",
      "hintText": "标题字数 10字以上"
    },
    model: {
      value: (_vm.title),
      callback: function($$v) {
        _vm.title = $$v
      },
      expression: "title"
    }
  }), _vm._v(" "), _c('mu-text-field', {
    staticClass: "text content",
    attrs: {
      "hintText": "输入文本",
      "multiLine": "",
      "rows": 5,
      "underlineShow": false
    },
    model: {
      value: (_vm.content),
      callback: function($$v) {
        _vm.content = $$v
      },
      expression: "content"
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    staticClass: "demo-raised-button",
    attrs: {
      "label": "发布话题",
      "icon": "near_me",
      "primary": ""
    },
    on: {
      "click": _vm.setData
    }
  })], 1), _vm._v(" "), _c('mu-raised-button', {
    attrs: {
      "label": "请选择"
    },
    on: {
      "click": _vm.open
    }
  }), _vm._v(" "), _c('mu-dialog', {
    attrs: {
      "open": _vm.dialog,
      "title": "提示"
    }
  }, [_vm._v("\n          请登录\n        "), _c('mu-flat-button', {
    attrs: {
      "slot": "actions",
      "to": "/index",
      "primary": "",
      "label": "取消"
    },
    on: {
      "click": _vm.close
    },
    slot: "actions"
  }), _vm._v(" "), _c('mu-flat-button', {
    attrs: {
      "slot": "actions",
      "primary": "",
      "to": "/userinfo",
      "label": "确定"
    },
    on: {
      "click": _vm.close
    },
    slot: "actions"
  })], 1), _vm._v(" "), _c('mu-dialog', {
    attrs: {
      "open": _vm.publish,
      "title": "提示："
    }
  }, [_vm._v("\n        " + _vm._s(_vm.tips) + "\n        "), _c('mu-flat-button', {
    attrs: {
      "slot": "actions",
      "primary": "",
      "label": "确定"
    },
    on: {
      "click": _vm.close
    },
    slot: "actions"
  })], 1), _vm._v(" "), _c('mfooter')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3baebfe8","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Create.vue
// module id = 154
// module chunks = 2